import { useQuery } from "react-query";
import type { LanguageCode } from "../../../utils/language";
import { getBlogDetailBySlug } from "../api/blogService";

export const useBlogDetail = (slug: string, language: LanguageCode) => {
  return useQuery(["blogDetail", slug, language], () => getBlogDetailBySlug(slug, language), {
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
  });
};
